import { h } from "preact";
import { capitalize } from "../../../utils/format.js";

/**
 * Радио-кнопки в виде таблеток.
 *
 * Пропсы:
 *   items    — массив значений (строк)
 *   selected — выбранное значение
 *   onchange — колбэк (value) => void
 *   template — шаблон подписи, например "*мм" → "40x50мм"
 *   name     — общий name для группы radio (опционально)
 */
export function OptionList({ items = [], selected, onchange, template = null, name }) {
  function label(item) {
    return capitalize(template ? template.replace("*", item) : item);
  }

  return h("fieldset", { class: "option-list" },
    items.map((item) => {
      const isSelected = selected === item;
      return h("label", {
        key: item,
        class: "option-list__item" + (isSelected ? " is--selected" : ""),
      },
        h("input", {
          type: "radio",
          name,
          value: item,
          checked: isSelected,
          onchange: () => onchange(item),
          class: "visually-hidden",
        }),
        label(item)
      );
    })
  );
}
